// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2x-6";
export var headerCell = "_2x-2";
export var loadingStateContent = "_2x-8";
export var rowWrapper = "_2x-4";
export var stickyAggregationCell = "_2x-b";
export var stickyAggregationRow = "_2x-7";
export var stickyColumnCell = "_2x-a";
export var stickyColumnHeaderCell = "_2x-9";
export var table = "_2x-1";
export var virtualRowWrapper = "_2x-5";
export var virtualTableBodyFiller = "_2x-d";
export var virtualTableBodyFillerBottom = "_2x-e";
export var virtualTableContainer = "_2x-0";
export var virtualTableContainerFill = "_2x-c";
export var white = "_2x-3";